<template>
	<a-form layout="vertical" class="g-pay-media-edit-form">
		<div class="g-pay-media-edit-form__row">
			<a-form-item v-if="showTitle" label="标题" class="g-pay-media-edit-form__col">
				<a-input v-model:value="form.title" :placeholder="titlePlaceholder" />
			</a-form-item>
			<a-form-item v-if="showSubtitle" label="副标题" class="g-pay-media-edit-form__col">
				<a-input v-model:value="form.subtitle" :placeholder="subtitlePlaceholder" />
			</a-form-item>
		</div>
		<div class="g-pay-media-edit-form__row">
			<a-form-item label="现价" class="g-pay-media-edit-form__col">
				<a-input v-model:value="form.price" placeholder="例如 9.90" />
			</a-form-item>
			<a-form-item
				v-if="mode === 'duration'"
				label="免费时长(秒)"
				class="g-pay-media-edit-form__col"
			>
				<a-input-number
					v-model:value="form.freePreviewDuration"
					:min="0"
					:max="maxDuration || undefined"
					:precision="0"
					style="width: 100%;"
				/>
			</a-form-item>
			<a-form-item
				v-else
				label="免费个数"
				class="g-pay-media-edit-form__col"
			>
				<a-input-number
					v-model:value="form.freePreviewCount"
					:min="0"
					:max="maxCount || undefined"
					:precision="0"
					style="width: 100%;"
				/>
			</a-form-item>
		</div>
		<div class="g-pay-media-edit-form__row">
			<a-form-item label="按钮文字" class="g-pay-media-edit-form__col">
				<a-input v-model:value="form.buttonText" placeholder="立即解锁" />
			</a-form-item>
			<a-form-item label="按钮颜色" class="g-pay-media-edit-form__col">
				<div class="g-pay-media-edit-form__colors">
					<ColorPicker v-model="form.buttonBg"  :swatch-width="29" :swatch-height="29" />
					<a-input v-model:value="form.buttonBg" />
				</div>
			</a-form-item>
		</div>
	</a-form>
</template>

<script>
	import ColorPicker from './ColorPicker.vue';

	export default {
		name: 'GPayMediaEditForm',
		components: { ColorPicker },
		props: {
			form: { type: Object, required: true },
			mode: {
				type: String,
				default: 'count',
				validator: value => ['count', 'duration'].includes(value),
			},
			maxDuration: { type: Number, default: 0 },
			maxCount: { type: Number, default: 0 },
			showTitle: { type: Boolean, default: true },
			showSubtitle: { type: Boolean, default: true },
			titlePlaceholder: { type: String, default: '' },
			subtitlePlaceholder: { type: String, default: '' },
		},
		methods: {
			normalizeColor(value) {
				if (/^#[0-9a-fA-F]{6}$/.test(value || '')) return value;
				return '#285af9';
			},
			onColorInput(color) {
				this.form.buttonBg = color;
			},
		},
	};
</script>

<style scoped lang="less">
	.g-pay-media-edit-form__row {
		display: flex;
		gap: 16px;
	}

	.g-pay-media-edit-form__col {
		flex: 1;
		min-width: 0;
	}

	.g-pay-media-edit-form__colors {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.g-pay-media-edit-form__swatch {
		position: relative;
		width: 28px;
		height: 28px;
		border-radius: 4px;
		overflow: hidden;
		cursor: pointer;
	}

	.g-pay-media-edit-form__color-input {
		position: absolute;
		inset: 0;
		opacity: 0;
		cursor: pointer;
	}
</style>
